import { Alert, Button, HStack, Text } from '@chakra-ui/react';
import { FiEye } from 'react-icons/fi'
import type { TurfGenerationChangeSummaryDto } from '../../../types/campaign'

interface Props {
  changes: TurfGenerationChangeSummaryDto[]
  onViewPreviousGeneration: (turfMapId: string) => void
}

function formatDate(dateStr: string): string {
  const d = new Date(dateStr)
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })
}

export function GenerationChangeBanner({ changes, onViewPreviousGeneration }: Props) {
  if (changes.length === 0) return null

  return (
    <>
      {changes.map(change => (
        <Alert.Root
          key={change.turfMapId}
          status="info"
          borderRadius="md"
          variant='subtle'
          borderStartWidth='3px'
          borderStartColor='colorPalette.solid'>
          <Alert.Indicator />
          <Alert.Description flex={1}>
            <HStack justify="space-between" flexWrap="wrap" gap={2}>
              <Text fontSize="sm">
                <Text as="span" fontWeight="medium">{change.turfMapLabel}</Text>
                {' '}was re-cut on {formatDate(change.changedAt)}.{' '}
                {change.newTurfCount} new turf{change.newTurfCount !== 1 ? 's' : ''} replaced{' '}
                {change.oldTurfCount} from Gen {change.oldGeneration}.{' '}
                {change.redistributedContactCount.toLocaleString()} contacts redistributed.
              </Text>
              {change.previousGenerationId && (
                <Button
                  size="xs"
                  variant="ghost"
                  colorPalette="brand"
                  onClick={() => onViewPreviousGeneration(change.previousGenerationId!)}><FiEye />View previous
                                  </Button>
              )}
            </HStack>
          </Alert.Description>
        </Alert.Root>
      ))}
    </>
  );
}
